import { render, staticRenderFns } from "./Englishnavigation.vue?vue&type=template&id=2e516f3b&scoped=true&"
import script from "./Englishnavigation.vue?vue&type=script&lang=js&"
export * from "./Englishnavigation.vue?vue&type=script&lang=js&"
import style0 from "./Englishnavigation.vue?vue&type=style&index=0&id=2e516f3b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e516f3b",
  null
  
)

export default component.exports